(function($) {
	'use strict';
	$.fn.Collection__Unarchive = function() {
		this.each(function() { 
			
			/*
			 * Action: Archive Collection
			 */
			var $self = $(this),
				collection_id = $self.data('cid');
			
			// Listener
			$self.off( $.Globals.clickEvent ).on( $.Globals.clickEvent, function(e) {
				e.preventDefault();
				
				// Add confirm
				var confirmed = confirm( Front.translations.confirm_unarchive );

				if( confirmed ) {
					
					// Note: scspaces_archive_collection handles archive and unarchive
					$.Globals.ajax( 'scspaces_archive_collection', { cid: collection_id }, function( data ) {
						if( data.success ) {
							
							// We don't have that collection anymore.  Go to my collections.
							window.location = Front.my_collections_url;
							
						} else {
							
							console.log(data);
							
						}
					});

				}
				
			});
		
		});
		return this;
	};
}(jQuery));